const ENBusinessGroup = {
	"Adicionar empresa": "Add company",
	"Adicionar grupo de empresa": "Add business group",
	"Adicionar item do contrato": "Add contract item",
	"Alterar grupo de empresa": "Change business group",
	"Alterar item do contrato": "Change contract item",
	"Ativo é requerido": "Active is required",
	"Contrato excluído com sucesso": "Contract successfully deleted",
	"Deseja realmente excluir o contrato": "Do you really want to delete the contract",
	"Deseja realmente excluir o grupo": "Do you really want to delete the group",
	"Deseja realmente excluir o plano comercial {{name}} do grupo empresa": "Do you really want to delete the commercial plan {{name}} from the business group",
	"Deseja realmente revalidar este plano comercial": "Do you really want to revalidate this business plan",
	"Digite o nome do grupo para excluí-lo": "Enter the name of the group to delete it",
	"Erro ao adicionar grupo empresa": "Error adding business group",
	"Erro ao adicionar item de contrato": "Error adding contract item",
	"Erro ao alterar item de contrato": "Error changing contract item",
	"Erro ao excluir contrato": "Error deleting contract",
	"Erro ao excluir grupo empresa": "Error deleting business group",
	"Erro ao selecionar dados do contrato": "Error selecting contract data",
	"Este CNPJ é inválido": "This CNPJ is invalid",
	"Exclusão do grupo de empresa": "Delete business group",
	"Excluir contrato de empresa": "Delete company agreement",
	"Excluir plano comercial": "Delete commercial plan",
	"Grupo é requerido": "Group is required",
	"Grupo empresa": "Business group",
	"Grupo empresa adicionado com sucesso": "Business group successfully added",
	"Grupo empresa alterado com sucesso": "Business group successfully changed",
	"Grupo empresa excluído com sucesso": "Business group successfully deleted",
	"Grupo de empresas": "Business groups",
	"Item do contrato": "Contract item",
	"Itens do contrato": "Contract items",
	"Item de contrato adicionado com sucesso": "Successfully added contract item",
	"Item de contrato alterado com sucesso": "Contract item changed successfully",
	"Nome do grupo não confere": "Group name does not match",
	"Nome fantasia": "Trading name",
	"Nome fantasia é requerido": "Trading name is required",
	"Novo grupo": "New group",
	"Período de validade": "Validity period",
	"Plano comercial foi revalidado e será o vigente a partir da data": "Commercial plan has been revalidated and will be in effect as of the date",
	"Prefixo é requerido": "Prefix is required",
	"Razão social": "Business name",
	"Razão social é requerido": "Business name is required",
	"Revalidar plano comercial": "Revalidate business plan",
	"Troca de plano comercial": "Change commercial plan",
	"Trocar plano comercial": "Change commercial plans",
	"Visualizar contratos": "View contracts"
};

export default ENBusinessGroup;
